import { ValidationError } from 'yup';
import { isNullOrUndefined } from '@utils/utils.tsx';

export const findErrorMessage = (errors: ValidationError[], path: string, t: any) => {
  if (isNullOrUndefined(errors)) return null;

  const error = errors.find(e => e.path === path);

  if (isNullOrUndefined(error)) return undefined;

  if (isNullOrUndefined(error.message))
    return t(`validation.${error.type}`);
  else
    return error.message;
};